import { useContext, useEffect, useState } from "react";
import {
  ACCOUNT_DELETE,
  CHANGE_PASSWORD,
  GET_ALL_CATEGORIES,
  GET_ALL_MY_ADS,
  GET_ALL_STATE_BY_COUNTY_ID,
  GET_CITY_BY_STATE_ID,
  UPDATE_USER_PROFILE,
  USER_PROFILE,
  fetchData,
} from "../../components/Service";
import {
  Link,
  useNavigate,
  useSearchParams,
} from "../../../node_modules/react-router-dom/dist/index";
import { Context } from "../../components/Context";
import _, { set } from "lodash";
import moment from "../../../node_modules/moment/moment";
import { scrollTop } from "../../components/Helper";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import Dropzone from "../../components/Dropzone";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import DatePicker from "react-date-picker";
import Select from "react-select";
import { PhoneNumberUtil } from "google-libphonenumber";
import {
  PhoneInput,
  defaultCountries,
  parseCountry,
} from "react-international-phone";
import "react-international-phone/style.css";
import { destroyCookie } from "nookies";

const phoneUtil = PhoneNumberUtil.getInstance();

const MyProfile = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  console.log(searchParams.get("tab"));
  const [context, setContext] = useContext(Context);
  const [data, setData] = useState();
  const [page, setPage] = useState(
    searchParams.get("tab") ? searchParams.get("tab") : "profile"
  );
  const [adsListPage, setAdsListPage] = useState(0)
  const [pageTitle, setPageTitle] = useState(
    searchParams.get("tab") ? "My Ads" : "My Profile"
  );
  const [adsList, setAdsList] = useState([]);
  const [adsListLimted, setAdsListLimted] = useState([]);
  const [catList, setCatList] = useState([]);
  const [notFound, setNotFound] = useState(false);
  const [pageUrl, setPageUrl] = useState();
  const [checkedItems, setCheckedItems] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [file, setFile] = useState("");
  const [dob, setDob] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);

  const [showCurrentPassword, setShowCurrentPassword] = useState(true);
  const [showNewPassword, setShowNewPassword] = useState(true);
  const [showConfirmPassword, setShowConfirmPassword] = useState(true);

  const [defaultPhoneCountry] = useState("us");
  const [fullPhone, setFullPhone] = useState("");

  const countriesList =
    context?.countryList?.map((item) => item?.code?.toLowerCase()) || [];

  const countries = defaultCountries.filter((country) => {
    const { iso2 } = parseCountry(country);
    return countriesList.includes(iso2);
  });

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
    setValue,
    trigger,
    setError,
    clearErrors,
  } = useForm({ mode: "onChange" });

  // console.log(adsList)

  const isPhoneValid = (phone, country_code) => {
    try {
      // if (!phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone))) {
      // 	setError("mobile", { message: "Phone is invalid." });
      // 	setValue("mobile", "");
      // } else {
      // 	clearErrors("mobile");
      // 	setValue("mobile", phone);
      // }

      const onlyPhone = phone.replace(`+${country_code}`, "").trim();
      if (onlyPhone) {
        setValue("mobile", phone, { shouldValidate: true });
        clearErrors("mobile");
      } else {
        setValue("mobile", "");
      }
    } catch (error) {
      return false;
    }
  };

  const areaOfInterest = [
    { id: 0, name: "Real Estate" },
    { id: 1, name: "Carpool" },
    { id: 2, name: "Autos" },
    { id: 3, name: "Movies/Videos" },
    { id: 4, name: "Free Ads" },
    { id: 5, name: "Student Talk" },
    { id: 6, name: "Business Listing" },
  ];

  const handleAreaOfinterest = (event) => {
    const { name, checked } = event.target;

    setCheckedItems((prevItems) => {
      if (checked) {
        const updatedItems = [...prevItems, name];
        console.log("Selected items:", updatedItems.join(","));
        return updatedItems;
      } else {
        const updatedItems = prevItems.filter((item) => item !== name);
        console.log("Selected items:", updatedItems.join(","));
        setCheckedItems(updatedItems);
        return updatedItems;
      }
    });
  };

  const onFileDrop = (file, type) => {
    setFile(file);
  };

  const getAllStateByCountryId = (country_id) => {
    let value = {
      country_id: country_id,
    };

    fetchData(
      GET_ALL_STATE_BY_COUNTY_ID,
      "POST",
      value,
      false,
      false,
      (res) => {
        if (res.status) {
          setStateList(res?.data);
        } else {
          setStateList([]);
        }
      }
    );
  };

  const getAllCityByStateAndCountryId = (state_id, refress, cityId) => {
    let value = {
      state_id: [state_id],
    };

    fetchData(GET_CITY_BY_STATE_ID, "POST", value, false, false, (res) => {
      if (res.status) {
        setCityList(res?.data);
        if (refress) {
          console.log(cityId);
          setValue("city_id", cityId);
          setSelectedCity({
            value: cityId * 1,
            label: res?.data?.find((item) => item?.id === cityId * 1)?.name,
          });
        }
      } else {
        setCityList([]);
      }
    });
  };

  const getDetails = () => {
    let payload = {
      user_id: context?.user?.user_id,
    };

    fetchData(USER_PROFILE, "POST", payload, true, false, (res) => {
      if (res.status) {
        setData(res?.data);
        setFullPhone(
          res?.data?.mobile
            ? res.data.mobile.startsWith("+")
              ? res.data.mobile
              : `+1${res.data.mobile}`
            : ""
        );

        setValue("first_name", res?.data?.first_name);
        setValue("last_name", res?.data?.last_name);
        setValue("email", res?.data?.email);
        setValue("mobile", res?.data?.mobile);
        setValue("address", res?.data?.address === "null" ? "" : res?.data?.address);
        setValue(
          "zipcode",
          res?.data?.zipcode === "null" ? "" : res?.data?.zipcode
        );
        setValue("country_id", context.user?.country_id);
        setSelectedCountry({
          value: context.user?.country_id,
          label: context?.countryList?.find(
            (item) => item?.id === context.user?.country_id
          )?.name,
        });
        getAllStateByCountryId(context.user?.country_id);
        setValue("state_id", res?.data?.state_id.id);
        setSelectedState({
          value: res?.data?.state_id.id,
          label: context?.stateList?.find(
            (item) => item?.id === res?.data?.state_id.id
          )?.name,
        });
        getAllCityByStateAndCountryId(
          res?.data?.state_id?.id,
          true,
          res?.data?.city?.id
        );
        // setValue("city_id", context.user?.city);
        // setSelectedCity({value:context.user?.city*1,label:cityList?.find((item) => item?.id === context.user?.city*1)?.name})

        setValue(
          "dob",
          res?.data?.dob
            ? moment(res?.data?.dob).format("YYYY-MM-DD").toString()
            : ""
        );
        if (res?.data?.area_interest) {

          setCheckedItems((res?.data?.area_interest).split(","));
        }
        setDob(
          res?.data?.dob
            ? moment(res?.data?.dob).format("YYYY-MM-DD").toString()
            : ""
        );
      } else {
        window.$("#loginModal").modal("show");
      }
    });
  };

  // const getALLAds = () => {
  //   let payload = {
  //     user_id: context?.user?.user_id,
  //   };

  //   fetchData(
  //     pageUrl ? pageUrl : GET_ALL_MY_ADS,
  //     "POST",
  //     payload,
  //     true,
  //     false,
  //     (res) => {
  //       if (res.status) {
  //         setNotFound(false);
  //         setAdsList(res?.data);
  //       } else {
  //         setNotFound(true);
  //         setAdsList([]);
  //       }
  //     }
  //   );
  // };
  const getALLAds = () => {
    let payload = {
      user_id: context?.user?.user_id,
    };

    fetchData(
      pageUrl ? pageUrl : GET_ALL_MY_ADS,
      "POST",
      payload,
      true,
      false,
      (res) => {
        if (res.status) {
          setNotFound(false);
          console.log(res)
          setAdsList(res?.data);
          setAdsListLimted(res?.data.slice(0, 10))
        } else {
          console.log("else")
          setNotFound(true);
          setAdsList([]);
        }
      }
    );
  };


  const getFreeAdsCatList = () => {
    fetchData(GET_ALL_CATEGORIES, "GET", "", false, false, (res) => {
      if (res.status) {
        setCatList(res.data);
      } else {
        setCatList([]);
      }
    });
  };

  const changePassword = (data) => {
    data = {
      user_id: context?.user?.user_id,
      ...data,
    };
    fetchData(CHANGE_PASSWORD, "POST", data, true, false, (res) => {
      if (res.status) {
        toast.success(res?.message);
        navigate("/");
        reset();
      } else {
        toast.error(res?.message);
      }
    });
  };

  const getCategoryForItem = (cat_id) => {
    return catList.find((cat) => cat?.id === cat_id);
  };

  const updateUser = (data) => {
    const formData = new FormData();

    formData.append("user_id", context?.user?.user_id);
    formData.append("first_name", data?.first_name);
    formData.append("last_name", data?.last_name);
    formData.append("email", data?.email);
    formData.append("mobile", data?.mobile ? data?.mobile : "");
    formData.append("dob", moment(data?.dob).format("YYYY-MM-DD"));
    formData.append("address", data?.address);
    formData.append("zipcode", data?.zipcode ? data?.zipcode : "");
    formData.append("state_id", data?.state_id ? data?.state_id : "");
    formData.append("country_id", data?.country_id ? data?.country_id : "");
    formData.append("city", data?.city_id ? data?.city_id : "");
    formData.append("area_interest", checkedItems.join(","));

    if (file && file.name) {
      formData.append("profile_image", file, file?.name);
    }

    fetchData(UPDATE_USER_PROFILE, "POST", formData, true, true, (res) => {
      if (res.status) {
        toast.success("Profile updated successfully.");
        getDetails();

        setPage("profile");
        setPageTitle("My Profile");
      } else {
        toast.error(res?.message);
      }
    });
  };

  const deleteAccount = () => {
    fetchData(
      ACCOUNT_DELETE,
      "POST",
      { user_id: context?.user?.user_id },
      true,
      false,
      (res) => {
        if (res.status) {
          window.$(`#deleteAccount`).modal("hide");
          toast.success("Account deleted successfully.");

          localStorage.removeItem("__nristoken");
          localStorage.removeItem("__nrisuser");

          destroyCookie(null, "NrisToken");
          destroyCookie(null, "NrisUser");

          setContext((prevValue) => ({
            ...prevValue,
            user: "",
            userToken: "",
          }));

          navigate("/");
        } else {
          toast.error(res?.message);
        }
      }
    );
  };

  const showConfirmationModel = () => {
    if (context?.userToken) {
      window.$(`#deleteAccount`).modal("show");
    } else {
      window.$("#loginModal").modal("show");
    }
  };

  useEffect(() => {
    scrollTop();
    if (context?.userToken) {
      getDetails();
      getALLAds();
      getFreeAdsCatList();
    }
  }, [context?.userToken]);
  console.log(dob)
  useEffect(() => {
    if (context?.userToken) {
      getALLAds();
    }
  }, [pageUrl]);

  const userFriendlyName = (name) => {
    if (name === "forums") {
      return "Forum"
    } else
      if (name === "nris_talks") {
        return "Nris Talks"
      } else
        if (name === "student_talks") {
          return "Student Talks"
        } else
          if (name === "carpools") {
            return "Carpools"
          } else {
            return name
          }

  }

  return (
    <div class="col-lg-12">
      <div class="card card-forum ">
        <div class="card-header usa-bg px-1">
          <div className="national-bg">
            <div className="row d-flex align-items-center ind1">
              <div className="col-lg-3">
                <h4 class="text-white d-flex mb-0 py-2">{pageTitle}</h4>
              </div>
              <div className="col-lg-9 ms-auto text-start text-lg-end ">
                <div class="list-tabs mt-0">
                  <ul class="nav nav-tabs nav-tabsbg" role="tablist">
                    <li
                      onClick={() => {
                        setPage("profile");
                        setPageTitle("My Profile");
                      }}
                    >
                      <a
                        class={page === "profile" ? "active" : ""}
                        id={`nav-tab-job-profile`}
                        href={`#tab-job-profile`}
                        data-bs-toggle="tab"
                        role="tab"
                        aria-controls={`tab-job-profile`}
                        aria-selected={page === "profile"}
                      >
                        My Profile
                      </a>
                    </li>
                    <li
                      onClick={() => {
                        setPage("ads");
                        setPageTitle("My Ads");
                      }}
                    >
                      <a
                        class={page === "ads" ? "active" : ""}
                        id={`nav-tab-job-ads`}
                        href={`#tab-job-ads`}
                        data-bs-toggle="tab"
                        role="tab"
                        aria-controls={`tab-job-ads`}
                        aria-selected={page === "ads"}
                      >
                        My Ads
                      </a>
                    </li>
                    <li
                      onClick={() => {
                        setPage("edit");
                        setPageTitle("Edit Profile");
                      }}
                    >
                      <a
                        class={page === "edit" ? "active" : ""}
                        id={`nav-tab-job-edit`}
                        href={`#tab-job-edit`}
                        data-bs-toggle="tab"
                        role="tab"
                        aria-controls={`tab-job-edit`}
                        aria-selected={page === "edit"}
                      >
                        Edit Profile
                      </a>
                    </li>
                    <li
                      onClick={() => {
                        setPage("password");
                        setPageTitle("Change Password");
                      }}
                    >
                      <a
                        class={page === "password" ? "active" : ""}
                        id={`nav-tab-job-password`}
                        href={`#tab-job-password`}
                        data-bs-toggle="tab"
                        role="tab"
                        aria-controls={`tab-job-password`}
                        aria-selected={page === "password"}
                      >
                        Change Password
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-body bg-white p-1">
          <div class="card mb-3">
            <div class="row g-0 align-items-stretch">
              {/* <div class="col-xl-6">
								<img src={data?.image ? data?.image : "/assets/images/no-image.jpg"} class="img-fluid rounded-3" />
							</div> */}
              {page == "profile" && (
                <div class="col-12">
                  <div class="card-body h-100">
                    <div class="mt-2">
                      <div class="tab-content" id={`myTabContent-${page}`}>
                        <div
                          class="tab-pane fade show active"
                          id={`tab-job1-${page}`}
                          role="tabpanel"
                          aria-labelledby={`tab-job1-${page}`}
                        >
                          <div class="row align-items-stretch">
                            <div class="col-10 mb-1">
                              <div className="table-responsive">
                                <table className="table table-borderless table-sm profile-table">
                                  {data?.image && (
                                    <tr>
                                      <td rowSpan={7}>
                                        <img
                                          src={data?.image}
                                          alt={data?.first_name}
                                          className="p-1 me-2 rounded"
                                          width={100}
                                        />
                                      </td>

                                    </tr>
                                  )}
                                  <tr> <td className="ps-0">
                                    <spab className="fw-light"> Name:</spab>
                                  </td>

                                    <td>
                                      {data?.first_name} {data?.last_name}
                                    </td></tr>
                                  <tr>
                                    <td className="ps-0">
                                      <spab className="fw-light">
                                        Mobile Number:
                                      </spab>
                                    </td>

                                    <td>{data?.mobile}</td>
                                  </tr>
                                  <tr>
                                    <td className="ps-0">
                                      <spab className="fw-light">Email:</spab>
                                    </td>

                                    <td>{data?.email}</td>
                                  </tr>
                                  <tr>
                                    <td
                                      className="ps-0"
                                      style={{ width: "140px" }}
                                    >
                                      <spab className="fw-light">
                                        Location:
                                      </spab>
                                    </td>

                                    <td>
                                      {data?.address
                                        ? `${data?.address === "null"
                                          ? ""
                                          : data?.address + ", "
                                        } `
                                        : ""}
                                      {data?.city?.name
                                        ? `${data?.city?.name === "null" ? "" : data?.city?.name}, `
                                        : ""}
                                      {data?.state_id?.name
                                        ? `${data?.state_id?.name}`
                                        : ""}
                                      {data?.zipcode ? data?.zipcode === "null"
                                        ? ""
                                        : ", " + data?.zipcode : ""}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className="ps-0">
                                      <spab className="fw-light">
                                        Date of Birth:{" "}
                                      </spab>
                                    </td>

                                    <td>
                                      {data?.dob
                                        ? moment(data?.dob).format(
                                          "DD-MMM-YYYY"
                                        )
                                        : ""}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className="ps-0">
                                      <spab className="fw-light">
                                        Area of Interest:{" "}
                                      </spab>
                                    </td>

                                    <td>{data?.area_interest}</td>
                                  </tr>
                                </table>
                              </div>
                            </div>
                            {/* <div class="col-2 mb-1">
															<div className="d-block text-end">
																<button className="btn btn-danger hover-up m-auto" type="button" onClick={showConfirmationModel}>
																	Delete Account
																</button>
															</div>
														</div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="modal fade pe-0"
                    id={`deleteAccount`}
                    data-bs-backdrop="static"
                    data-bs-keyboard="false"
                    tabindex="-1"
                    aria-labelledby="staticBackdropLabel"
                    aria-hidden="true"
                  >
                    <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                      <div className="modal-content apply-job-form">
                        <button
                          className="btn-close"
                          type="button"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></button>
                        <div className="modal-header d-block text-center border-bottom-0">
                          <h5 className="text-brand-1 text-capitalize">
                            Delete Account
                          </h5>
                        </div>
                        <div className="modal-body px-4 pt-1">
                          <div className=" d-block text-center mb-3">
                            <h6 className="text-brand-1">
                              Are you sure you want to permanently delete your
                              account?
                            </h6>
                            <p className="pb-4">
                              This cannot be undone. By deleting this account
                              you agree that, You will not able to login again
                              to your account. All your personal information
                              will be removed and this action is irreversible.
                            </p>
                            <button
                              className="btn btn-success hover-up m-auto me-3"
                              type="button"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            >
                              No
                            </button>
                            <button
                              className="btn btn-danger hover-up m-auto"
                              type="submit"
                              onClick={deleteAccount}
                            >
                              Yes
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {page == "ads" && (
                <>
                  <table class="table table-striped table-responsive">
                    <thead>
                      <tr>
                        <th scope="col">Title</th>
                        <th scope="col">Category</th>
                        <th scope="col">Views</th>
                        <th scope="col">Price</th>
                        <th scope="col">Type</th>
                        <th scope="col">Status</th>
                        <th scope="col">Created At</th>
                        <th scope="col">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {adsListLimted &&
                        adsListLimted?.length > 0 &&
                        adsListLimted?.map((item) => {
                          let category = getCategoryForItem(item?.cat_id);
                          return (
                            <tr key={item.id}>
                              <td>
                                {item?.status == 1 && item?.is_live == 1 ? (
                                  item?.type === "carpools" ? (
                                    <Link to={`/carpool/details/${item.id}`}>
                                      {item?.cat_id === 1
                                        ? "Local"
                                        : item?.cat_id === 2
                                          ? "Interstate"
                                          : item?.cat_id === 3
                                            ? "International"
                                            : item?.title}
                                    </Link>
                                  ) : (
                                    <Link to={
                                      item?.type === "free_classifieds"
                                        ? item?.cat_id === 5
                                          ? `/real-estate/${item.id}`
                                          : item?.cat_id === 1
                                            ? `/autos/${item.id}`
                                            : `/classifieds/details/${item.id}`
                                        : item?.type === "forums"
                                          ? `/forums/${item.id}`
                                          : item?.type === "nris_talks"
                                            ? `/nri-talks/${item.id}`
                                            : item?.type === "student_talks"
                                              ? `/student-talks/${item.id}`
                                              : "#"
                                    }>
                                      {item?.title}
                                    </Link>
                                  )
                                ) : (
                                  item?.type === "carpools" ? (
                                    item?.cat_id === 1 ? "Local" :
                                      item?.cat_id === 2 ? "Interstate" :
                                        item?.cat_id === 3 ? "International" :
                                          item?.title
                                  ) : (
                                    item?.title
                                  )
                                )}
                              </td>

                              <td>{item?.type === "free_classifieds" ? category ? category.name : "N/A" : userFriendlyName(item?.type)} </td>
                              <td>{item?.total_views ?? 0}</td>
                              <td>
                                {(() => {
                                  try {
                                    const otherDetails = JSON.parse(item?.other_details === "0" ? "[]" : item?.other_details || "[]");
                                    const currencyDetail = otherDetails.find((detail) => detail?.Currency);
                                    const priceDetail = otherDetails.find((detail) => detail?.Property_Price);

                                    const regex = /\((\w{3})\)$/;
                                    const match = currencyDetail?.Currency?.match(regex);

                                    const currency = match ? match[1] : "USD";
                                    const price = priceDetail?.Property_Price
                                      ? parseFloat(priceDetail.Property_Price).toFixed(2)
                                      : "0.00";

                                    const result = `${currency} ${price}`;
                                    return result === "USD 0.00" ? "N/A" : result;
                                  } catch (err) {
                                    console.error("Invalid JSON in other_details:", err);
                                    return "USD 0.00";
                                  }
                                })()}
                              </td>
                              <td>{item?.payment_status === "Approved" ? "Paid" : "Free"}</td>
                              <td>
                                {item?.is_live === 1
                                  ? "Approved"
                                  : item?.is_live === 0
                                    ? "Admin Approval Pending"
                                    : item?.is_live === 2
                                      ? "Rejected"
                                      : "Status Unknown"}
                              </td>
                              <td>
                                {item.created_at
                                  ? moment(item.created_at).format(
                                    "DD-MMM-YYYY"
                                  )
                                  : ""}
                              </td>
                              {/* <td>
                                {item?.status == 1 && item?.is_live == 1 ? (
                                  <Link to={`/classifieds/details/${item.id}`}>
                                    <i class="fi fi-br-eye"></i>
                                  </Link>
                                ) : (
                                  ""
                                )}
                              </td> */}
                              <td>
                                {item?.status == 1 && item?.is_live == 1 ? (
                                  <Link to={
                                    item?.type === "free_classifieds"
                                      ? item?.cat_id === 5
                                        ? `/real-estate/${item.id}`
                                        : item?.cat_id === 1
                                          ? `/autos/${item.id}`
                                          : `/classifieds/details/${item.id}`
                                      : item?.type === "forums"
                                        ? `/forums/${item.id}`
                                        : item?.type === "nris_talks"
                                          ? `/nri-talks/${item.id}`
                                          : item?.type === "student_talks"
                                            ? `/student-talks/${item.id}`
                                            : item?.type === "carpools"
                                              ? `/carpool/details/${item.id}`
                                              : "#"
                                  }>
                                    <i className="fi fi-br-eye"></i>
                                  </Link>
                                ) : (
                                  ""
                                )}
                              </td>

                            </tr>
                          );
                        })}
                      {notFound && (
                        <tr>
                          <td
                            className="text-center h6 text-danger py-3"
                            colSpan={7}
                          >
                            No Records Found!
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  {adsList && (
                    <nav className="pt-3">
                      <ul className="pagination justify-content-end">

                        {/* Previous Button */}
                        <li className={`page-item ${adsListPage <= 0 ? "disabled" : ""}`}>
                          <button
                            type="button"
                            className="page-link"
                            onClick={() => {
                              if (adsListPage > 0) {
                                const newPage = adsListPage - 1;
                                const start = newPage * 10;
                                const end = start + 10;
                                setAdsListLimted(adsList.slice(start, end));
                                setAdsListPage(newPage);
                              }
                            }}
                          >
                            <span aria-hidden="true">&laquo;</span> Previous
                          </button>
                        </li>

                        {/* Next Button */}
                        <li className={`page-item ${(adsListPage + 1) * 10 >= adsList.length ? "disabled" : ""}`}>
                          <button
                            type="button"
                            className="page-link"
                            onClick={() => {
                              console.log("first", (adsListPage + 1) * 10, adsList.length)
                              if ((adsListPage + 1) * 10 < adsList.length) {
                                const newPage = adsListPage + 1;
                                const start = newPage * 10;
                                const end = start + 10;
                                setAdsListLimted(adsList.slice(start, end));
                                setAdsListPage(newPage);
                              }
                            }}
                          >
                            Next <span aria-hidden="true">&raquo;</span>
                          </button>
                        </li>

                      </ul>
                    </nav>
                  )}

                </>
              )}

              {page == "password" && (
                <div class="col-12">
                  <div class="card-body h-100">
                    <form
                      className="login-register text-start mt-20 pb-30 needs-validation"
                      onSubmit={handleSubmit(changePassword)}
                    >
                      <div className="row justify-content-md-center">
                        <div className="col-4 my-2 ">
                          <label>
                            Current Password{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <div className="input-group">
                            <input
                              className={`form-control bg-transparent ${errors.current_password && "is-invalid"
                                }`}
                              placeholder="Current Password"
                              type={!showCurrentPassword ? "text" : "password"}
                              {...register("current_password", {
                                required: {
                                  value: true,
                                  message: "Current password is required.",
                                },
                              })}
                              onPaste={(e) => {
                                e.preventDefault();
                                const pasted = e.clipboardData.getData("text").replace(/\s/g, "");
                                setValue("current_password", pasted, { shouldValidate: true }); // ✅ this updates react-hook-form state
                              }}
                              onChange={(e) => {
                                const cleaned = e.target.value.replace(/\s/g, "");
                                setValue("current_password", cleaned, { shouldValidate: true }); // ✅ this updates react-hook-form state
                                trigger("current_password");
                              }}
                            />
                            <button
                              type="button"
                              className={`btn btn-outline-secondary ${errors.current_password && "is-invalid"
                                }`}
                              onClick={() =>
                                setShowCurrentPassword(!showCurrentPassword)
                              }
                            >
                              {!showCurrentPassword ? (
                                <FaEyeSlash />
                              ) : (
                                <FaEye />
                              )}
                            </button>
                          </div>
                          {errors.current_password && (
                            <div class="invalid-feedback d-block">
                              {errors.current_password.message}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="row justify-content-md-center">
                        <div className="col-4 my-2 ">
                          <label>
                            New Password <span className="text-danger">*</span>
                          </label>
                          <div className="input-group">
                            <input
                              className={`form-control bg-transparent ${errors.new_password && "is-invalid"
                                }`}
                              placeholder="New Password"
                              type={!showNewPassword ? "text" : "password"}
                              {...register("new_password", {
                                required: {
                                  value: true,
                                  message: "New password is required.",
                                },
                                minLength: {
                                  value: 8,
                                  message:
                                    "New password must be at least 8 characters.",
                                },
                                pattern: {
                                  value:
                                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/,
                                  message:
                                    "New password must contain one uppercase, lowercase letter, number, special characters.",
                                },
                              })}
                              onPaste={(e) => {
                                e.preventDefault();
                                const pasted = e.clipboardData.getData("text").replace(/\s/g, "");
                                setValue("new_password", pasted, { shouldValidate: true }); // ✅ this updates react-hook-form state
                              }}
                              onChange={(e) => {
                                const cleaned = e.target.value.replace(/\s/g, "");
                                setValue("new_password", cleaned, { shouldValidate: true }); // ✅ this updates react-hook-form state
                                trigger("new_password");
                              }}
                            />
                            <button
                              type="button"
                              className={`btn btn-outline-secondary ${errors.new_password && "is-invalid"
                                }`}
                              onClick={() =>
                                setShowNewPassword(!showNewPassword)
                              }
                            >
                              {!showNewPassword ? <FaEyeSlash /> : <FaEye />}
                            </button>
                          </div>
                          {errors.new_password && (
                            <div class="invalid-feedback d-block">
                              {errors.new_password.message}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="row justify-content-md-center">
                        <div className="col-4 my-2 ">
                          <label>
                            Confirm Password{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <div className="input-group">
                            <input
                              className={`form-control bg-transparent ${errors.retype_password && "is-invalid"
                                }`}
                              placeholder="Confirm Password"
                              type={!showConfirmPassword ? "text" : "password"}
                              {...register("retype_password", {
                                required: {
                                  value: true,
                                  message: "Confirm password is required.",
                                },
                                validate: (val) => {
                                  if (watch("new_password") != val) {
                                    return "Password does not match.";
                                  }
                                },
                              })}
                              onPaste={(e) => {
                                e.preventDefault();
                                const pasted = e.clipboardData.getData("text").replace(/\s/g, "");
                                setValue("retype_password", pasted, { shouldValidate: true }); // ✅ this updates react-hook-form state
                              }}
                              onChange={(e) => {
                                const cleaned = e.target.value.replace(/\s/g, "");
                                setValue("retype_password", cleaned, { shouldValidate: true }); // ✅ this updates react-hook-form state
                                trigger("retype_password");
                              }}
                            />
                            <button
                              type="button"
                              className={`btn btn-outline-secondary ${errors.retype_password && "is-invalid"
                                }`}
                              onClick={() =>
                                setShowConfirmPassword(!showConfirmPassword)
                              }
                            >
                              {!showConfirmPassword ? (
                                <FaEyeSlash />
                              ) : (
                                <FaEye />
                              )}
                            </button>
                          </div>
                          {errors.retype_password && (
                            <div class="invalid-feedback d-block">
                              {errors.retype_password.message}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="d-block text-center my-3">
                        <button
                          className="btn btn-default hover-up m-auto"
                          type="submit"
                          name="login"
                        >
                          Change Password
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              )}

              {page == "edit" && (
                <div class="col-12">
                  <div class="card-body h-100">
                    <form
                      className="login-register text-start mt-20 pb-30 needs-validation"
                      onSubmit={handleSubmit(updateUser)}
                    >
                      <div className="row">
                        <div className="col-md-12">
                          <div class="mb-2">
                            <label class="form-label font12">Image</label>
                            <Dropzone
                              onFileDrop={onFileDrop}
                              setError={setError}
                              clearErrors={clearErrors}
                              uploadFile="image"
                              fieldName="file"
                              className="dropzone"
                              fileName={file}
                            />
                            {file && <p>File Name: {file.name}</p>}
                            {errors.file && (
                              <div class="invalid-feedback d-block">
                                {errors.file.message}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-sm-6 mb-2">
                          <label>
                            First Name <span className="text-danger">*</span>
                          </label>
                          <input
                            className={`form-control bg-transparent ${errors.first_name && "is-invalid"
                              }`}
                            placeholder="First name"
                            {...register("first_name", {
                              required: {
                                value: true,
                                message: "First name is required.",
                              },
                              minLength: {
                                value: 2,
                                message: "First name is too short.",
                              },
                              maxLength: {
                                value: 50,
                                message: "First name is too long.",
                              },
                              pattern: {
                                value: /^[A-Za-z]+$/,
                                message:
                                  "Only alphabetic characters are allowed.",
                              },
                            })}
                            readOnly
                          />
                          {errors.first_name && (
                            <div class="invalid-feedback">
                              {errors.first_name.message}
                            </div>
                          )}
                        </div>
                        <div className="col-xl-4 col-lg-4 col-sm-6 mb-2">
                          <label>
                            Last Name <span className="text-danger">*</span>
                          </label>
                          <input
                            className={`form-control bg-transparent ${errors.last_name && "is-invalid"
                              }`}
                            placeholder="Last name"
                            {...register("last_name", {
                              required: {
                                value: true,
                                message: "Last name is required.",
                              },
                              minLength: {
                                value: 2,
                                message: "Last name is too short.",
                              },
                              maxLength: {
                                value: 50,
                                message: "Last name is too long.",
                              },
                              pattern: {
                                value: /^[A-Za-z]+$/,
                                message:
                                  "Only alphabetic characters are allowed.",
                              },
                            })}
                            readOnly
                          />
                          {errors.last_name && (
                            <div class="invalid-feedback">
                              {errors.last_name.message}
                            </div>
                          )}
                        </div>
                        <div className="col-xl-4 col-lg-4 col-sm-6 mb-2">
                          <label>
                            Email <span className="text-danger">*</span>
                          </label>
                          <input
                            className={`form-control bg-transparent ${errors.email && "is-invalid"
                              }`}
                            placeholder="Email"
                            type="email"
                            readOnly
                            maxLength={120}
                            {...register("email", {
                              required: {
                                value: true,
                                message: "Email is required.",
                              },
                              pattern: {
                                value:
                                  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                                message: "Email is invalid.",
                              },
                            })}
                          />
                          {errors.email && (
                            <div class="invalid-feedback">
                              {errors.email.message}
                            </div>
                          )}
                        </div>
                        <div className="col-xl-4 col-lg-4 col-sm-6 mb-2">
                          <label>Phone</label>

                          <PhoneInput
                            key={defaultPhoneCountry}
                            defaultCountry={defaultPhoneCountry}
                            countries={countries}
                            forceDialCode={true}
                            value={fullPhone}
                            hideDropdown={false}
                            disableCountryGuess={false}
                            onChange={(phone, country) => {
                              isPhoneValid(phone, country.country.dialCode);
                              setFullPhone(phone);
                              setValue(
                                "country_code",
                                `+${country.country.dialCode}` || "+1"
                              );
                            }}
                            className={`form-control bg-transparent p-0 ${errors.mobile ? "is-invalid" : ""
                              }`}
                          />
                          <input type="hidden" {...register("mobile")} />

                          {errors.mobile && (
                            <div class="invalid-feedback">
                              {errors.mobile.message}
                            </div>
                          )}
                        </div>
                        <div className="col-xl-4 col-lg-4 col-sm-6 mb-2">
                          <label>
                            Dob <span className="text-danger">*</span>
                          </label>
                          <div className="custom-datepicker-wrapper">
                            <DatePicker
                              className={`form-control bg-transparent dp ${errors.dob && "is-invalid"
                                }`}
                              clearIcon={false}
                              monthPlaceholder="MM"
                              dayPlaceholder="DD"
                              yearPlaceholder="YYYY"
                              onChange={(date) => {
                                setDob(date);
                                setValue("dob", date, { shouldValidate: true });
                              }}
                              maxDate={new Date()}
                              minDate={new Date("01-01-1900")}

                              value={new Date(dob)}
                            />
                          </div>

                          <input
                            type="hidden"
                            {...register("dob", {
                              required: "Date of birth is required.",
                            })}
                          />
                          {errors.dob && (
                            <div class="invalid-feedback d-block">
                              {errors.dob.message}
                            </div>
                          )}
                        </div>
                        <div className="col-xl-4 col-lg-4 col-sm-6 mb-2">
                          <label>Address</label>
                          <input
                            class={`form-control ${errors.address && "is-invalid"
                              }`}
                            rows="5"
                            placeholder="Address"
                            {...register("address", {
                              minLength: {
                                value: 3,
                                message:
                                  "Address must be at least 3 characters.",
                              },
                            })}
                          ></input>
                          {errors.address && (
                            <div class="invalid-feedback d-block">
                              {errors.address.message}
                            </div>
                          )}
                        </div>
                        <div className="col-3 mb-2">
                          <label>
                            Country <span className="text-danger">*</span>
                          </label>

                          <Select
                            {...register("country_id", {
                              required: {
                                value: true,
                                message: "Select a country.",
                              },
                            })}
                            options={context?.countryList?.map((item) => ({
                              label: item.name,
                              value: item.id,
                            }))}
                            value={selectedCountry}
                            onChange={(selected) => {
                              setSelectedCountry(selected);
                              console.log(selected);
                              getAllStateByCountryId(
                                selected ? selected.value : ""
                              );
                              setValue(
                                "country_id",
                                selected ? selected.value : ""
                              );
                              trigger("country_id");

                              setSelectedState(null);
                              setSelectedCity(null);
                              setValue("state_id", "");
                              trigger("state_id");

                              setValue("city_id", "");
                              trigger("city_id");
                            }}
                            placeholder="Select a country"
                            className={`selectpicker p-0 ${errors.country_id && "is-invalid bdr-red"
                              }`}
                            classNamePrefix="react-select"
                          />
                          {errors.country_id && (
                            <div class="invalid-feedback d-block">
                              {errors.country_id.message}
                            </div>
                          )}
                        </div>

                        <div className="col-3 mb-2">
                          <label>
                            State <span className="text-danger">*</span>
                          </label>

                          <Select
                            {...register("state_id", {
                              required: {
                                value: true,
                                message: "Select a state.",
                              },
                            })}
                            options={stateList?.map((item) => ({
                              label: item.name,
                              value: item.id,
                            }))}
                            value={selectedState}
                            onChange={(selected) => {
                              setSelectedState(selected);
                              getAllCityByStateAndCountryId(
                                selected ? selected.value : ""
                              );
                              setValue(
                                "state_id",
                                selected ? selected.value : ""
                              );
                              trigger("state_id");

                              setSelectedCity(null);

                              setValue("city_id", "");
                              trigger("city_id");
                            }}
                            placeholder="Select a state"
                            className={`selectpicker p-0 ${errors.state_id && "is-invalid bdr-red"
                              }`}
                            classNamePrefix="react-select"
                          />
                          {errors.state_id && (
                            <div class="invalid-feedback d-block">
                              {errors.state_id.message}
                            </div>
                          )}
                        </div>

                        <div className="col-3 mb-2">
                          <label>City</label>

                          <Select
                            {...register("city_id", {})}
                            options={cityList?.map((item) => ({
                              label: item.name,
                              value: item.id,
                            }))}
                            value={selectedCity}
                            onChange={(selected) => {
                              setSelectedCity(selected);
                              setValue(
                                "city_id",
                                selected ? selected.value : ""
                              );
                              trigger("city_id");
                            }}
                            placeholder="Select a city"
                            className={`selectpicker p-0 ${errors.city_id && "is-invalid bdr-red"
                              }`}
                            classNamePrefix="react-select"
                          />
                          {errors.city_id && (
                            <div class="invalid-feedback d-block">
                              {errors.city_id.message}
                            </div>
                          )}
                        </div>
                        <div className="col-3 mb-2">
                          <label>Zip Code</label>
                          <input
                            className={`form-control bg-transparent ${errors.zipcode && "is-invalid"
                              }`}
                            placeholder="Zip Code"
                            maxLength={10}
                            {...register("zipcode", {
                              pattern: {
                                value:
                                  /^(\d{5}(-\d{4})?|\d{4}|[A-Z]\d[A-Z] \d[A-Z]\d|[A-Z]{1,2}\d[A-Z\d]? \d[A-Z]{2})$/,
                                message: "Zip code is invalid.",
                              },
                            })}
                          />
                          {errors.zipcode && (
                            <div class="invalid-feedback">
                              {errors.zipcode.message}
                            </div>
                          )}
                        </div>
                        <div className="col-12">
                          <label>Area of interest</label>
                          <div className="row">
                            {areaOfInterest?.map((item) => (
                              <div
                                key={item.id}
                                className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-2"
                              >
                                <label className="cb-container">
                                  <input
                                    type="checkbox"
                                    name={item.name}
                                    onChange={(e) => handleAreaOfinterest(e)}
                                    checked={checkedItems.includes(item.name)}
                                  />
                                  <span className="text-small">
                                    {item.name}
                                  </span>
                                  <span className="checkmark"></span>
                                </label>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer d-block text-center mt-3">
                        <button
                          className={`btn btn-default hover-up m-auto`}
                          type="submit"
                          name="signup"
                        >
                          Update Profile
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyProfile;
